// GENERAL APP ACTION TYPES
export const APP__GET_SYSTEM_INFORMATION_REQUEST = 'APP__GET_SYSTEM_INFORMATION_REQUEST';
export const APP__GET_SYSTEM_INFORMATION_SUCCESS = 'APP__GET_SYSTEM_INFORMATION_SUCCESS';
export const APP__GET_SYSTEM_INFORMATION_FAILURE = 'APP__GET_SYSTEM_INFORMATION_FAILURE';

// SESSION ACTION TYPES
export const LOGOUT__USER_REQUEST = 'LOGOUT__USER_REQUEST';
export const LOGOUT__USER_SUCCESS = 'LOGOUT__USER_SUCCESS';
export const LOGOUT__USER_FAILURE = 'LOGOUT__USER_FAILURE';

export const LOGIN__USER_REMEMBER_ME_REQUEST = 'LOGIN__USER_REMEMBER_ME_REQUEST';
export const LOGIN__USER_REMEMBER_ME_SUCCESS = 'LOGIN__USER_REMEMBER_ME_SUCCESS';
export const LOGIN__USER_REMEMBER_ME_FAILURE = 'LOGIN__USER_REMEMBER_ME_FAILURE';

export const SESSION__REFRESH_TOKEN_REQUEST = 'SESSION__REFRESH_TOKEN_REQUEST';
export const SESSION__REFRESH_TOKEN_SUCCESS = 'SESSION__REFRESH_TOKEN_SUCCESS';
export const SESSION__REFRESH_TOKEN_FAILURE = 'SESSION__REFRESH_TOKEN_FAILURE';

// REGISTRATION ACTION TYPES

export const REGISTRATION__UPDATE_POLICY = 'REGISTRATION__UPDATE_POLICY';
export const REGISTRATION__UPDATE_USER = 'REGISTRATION__UPDATE_USER';

export const REGISTRATION__REQUIRE_STAFF_VERIFICATION = 'REGISTRATION__REQUIRE_STAFF_VERIFICATION';

export const REGISTRATION__VERIFY_POLICY_REQUEST = 'REGISTRATION__VERIFY_POLICY_REQUEST';
export const REGISTRATION__VERIFY_POLICY_SUCCESS = 'REGISTRATION__VERIFY_POLICY_SUCCESS';
export const REGISTRATION__VERIFY_POLICY_FAILURE = 'REGISTRATION__VERIFY_POLICY_FAILURE';

export const REGISTRATION__VERIFY_ACCOUNT_NUMBER_REQUEST = 'REGISTRATION__VERIFY_ACCOUNT_NUMBER_REQUEST';
export const REGISTRATION__VERIFY_ACCOUNT_NUMBER_SUCCESS = 'REGISTRATION__VERIFY_ACCOUNT_NUMBER_SUCCESS';
export const REGISTRATION__VERIFY_ACCOUNT_NUMBER_FAILURE = 'REGISTRATION__VERIFY_ACCOUNT_NUMBER_FAILURE';

export const REGISTRATION__VERIFY_FULL_POLICY_REQUEST = 'REGISTRATION__VERIFY_FULL_POLICY_REQUEST';
export const REGISTRATION__VERIFY_FULL_POLICY_SUCCESS = 'REGISTRATION__VERIFY_FULL_POLICY_SUCCESS';
export const REGISTRATION__VERIFY_FULL_POLICY_FAILURE = 'REGISTRATION__VERIFY_FULL_POLICY_FAILURE';

export const REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_REQUEST = 'REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_REQUEST';
export const REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_SUCCESS = 'REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_SUCCESS';
export const REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_FAILURE = 'REGISTRATION__VERIFY_POLICY_BY_PAYMENT_NUMBER_FAILURE';

export const REGISTRATION__VERIFY_POLICY_BYSTAFF_REQUEST = 'REGISTRATION__VERIFY_POLICY_BYSTAFF_REQUEST';
export const REGISTRATION__VERIFY_POLICY_BYSTAFF_SUCCESS = 'REGISTRATION__VERIFY_POLICY_BYSTAFF_SUCCESS';
export const REGISTRATION__VERIFY_POLICY_BYSTAFF_FAILURE = 'REGISTRATION__VERIFY_POLICY_BYSTAFF_FAILURE';

export const REGISTRATION__CREATE_USER_REQUEST = 'REGISTRATION__CREATE_USER_REQUEST';
export const REGISTRATION__CREATE_USER_SUCCESS = 'REGISTRATION__CREATE_USER_SUCCESS';
export const REGISTRATION__CREATE_USER_FAILURE = 'REGISTRATION__CREATE_USER_FAILURE';

export const REGISTRATION__CONFIRM_EMAIL_REQUEST = 'REGISTRATION__CONFIRM_EMAIL_REQUEST';
export const REGISTRATION__CONFIRM_EMAIL_SUCCESS = 'REGISTRATION__CONFIRM_EMAIL_SUCCESS';
export const REGISTRATION__CONFIRM_EMAIL_FAILURE = 'REGISTRATION__CONFIRM_EMAIL_FAILURE';

export const REGISTRATION__RESEND_CONFIRMATION_EMAIL_REQUEST = 'REGISTRATION__RESEND_CONFIRMATION_EMAIL_REQUEST';
export const REGISTRATION__RESEND_CONFIRMATION_EMAIL_SUCCESS = 'REGISTRATION__RESEND_CONFIRMATION_EMAIL_SUCCESS';
export const REGISTRATION__RESEND_CONFIRMATION_EMAIL_FAILURE = 'REGISTRATION__RESEND_CONFIRMATION_EMAIL_FAILURE';

export const REGISTRATION__HAS_ACCOUNT_REQUEST = 'REGISTRATION__HAS_ACCOUNT_REQUEST';
export const REGISTRATION__HAS_ACCOUNT_SUCCESS = 'REGISTRATION__HAS_ACCOUNT_SUCCESS';
export const REGISTRATION__HAS_ACCOUNT_FAILURE = 'REGISTRATION__HAS_ACCOUNT_FAILURE';


// AUTH ACTION TYPES

export const AUTH__UPDATE_USER = 'AUTH__UPDATE_USER';
export const AUTH__SET_LEGACY_USER = 'AUTH__SET_LEGACY_USER';

export const AUTH__CHANGE_LEGACY_USER_REQUEST = 'AUTH__CHANGE_LEGACY_USER_REQUEST';
export const AUTH__CHANGE_LEGACY_USER_SUCCESS = 'AUTH__CHANGE_LEGACY_USER_SUCCESS';
export const AUTH__CHANGE_LEGACY_USER_FAILURE = 'AUTH__CHANGE_LEGACY_USER_FAILURE';

export const AUTH__AUTHENTICATE_USER_REQUEST = 'AUTH__AUTHENTICATE_USER_REQUEST';
export const AUTH__AUTHENTICATE_USER_SUCCESS = 'AUTH__AUTHENTICATE_USER_SUCCESS';
export const AUTH__AUTHENTICATE_USER_FAILURE = 'AUTH__AUTHENTICATE_USER_FAILURE';

export const AUTH__FORGOT_PASSWORD_REQUEST = 'AUTH__FORGOT_PASSWORD_REQUEST';
export const AUTH__FORGOT_PASSWORD_SUCCESS = 'AUTH__FORGOT_PASSWORD_SUCCESS';
export const AUTH__FORGOT_PASSWORD_FAILURE = 'AUTH__FORGOT_PASSWORD_FAILURE';

export const AUTH__RESET_PASSWORD_REQUEST = 'AUTH__RESET_PASSWORD_REQUEST';
export const AUTH__RESET_PASSWORD_SUCCESS = 'AUTH__RESET_PASSWORD_SUCCESS';
export const AUTH__RESET_PASSWORD_FAILURE = 'AUTH__RESET_PASSWORD_FAILURE';


// PROFILE ACTION TYPES
export const PROFILE__PASSWORD_CHANGED = 'PROFILE__PASSWORD_CHANGED';
export const PROFILE__EMAIL_CHANGED = 'PROFILE__EMAIL_CHANGED';
export const PROFILE__UPDATE_DELIVERY = 'PROFILE__UPDATE_DELIVERY';

export const PROFILE__CHANGE_PASSWORD_REQUEST = 'PROFILE__CHANGE_PASSWORD_REQUEST';
export const PROFILE__CHANGE_PASSWORD_SUCCESS = 'PROFILE__CHANGE_PASSWORD_SUCCESS';
export const PROFILE__CHANGE_PASSWORD_FAILURE = 'PROFILE__CHANGE_PASSWORD_FAILURE';

export const PROFILE__CHANGE_EMAIL_REQUEST = 'PROFILE__CHANGE_EMAIL_REQUEST';
export const PROFILE__CHANGE_EMAIL_SUCCESS = 'PROFILE__CHANGE_EMAIL_SUCCESS';
export const PROFILE__CHANGE_EMAIL_FAILURE = 'PROFILE__CHANGE_EMAIL_FAILURE';

export const PROFILE__CONFIRM_CHANGE_EMAIL_REQUEST = 'PROFILE__CONFIRM_CHANGE_EMAI_REQUEST';
export const PROFILE__CONFIRM_CHANGE_EMAIL_SUCCESS = 'PROFILE__CONFIRM_CHANGE_EMAI_SUCCESS';
export const PROFILE__CONFIRM_CHANGE_EMAIL_FAILURE = 'PROFILE__CONFIRM_CHANGE_EMAI_FAILURE';

export const PROFILE__GET_REQUEST = 'PROFILE__GET_REQUEST';
export const PROFILE__GET_SUCCESS = 'PROFILE__GET_SUCCESS';
export const PROFILE__GET_FAILURE = 'PROFILE__GET_FAILURE';

export const PROFILE__SAVE_DELIVERY_REQUEST = 'PROFILE__SAVE_DELIVERY_REQUEST';
export const PROFILE__SAVE_DELIVERY_SUCCESS = 'PROFILE__SAVE_DELIVERY_SUCCESS';
export const PROFILE__SAVE_DELIVERY_FAILURE = 'PROFILE__SAVE_DELIVERY_FAILURE';

export const PROFILE__UPDATE_MOBILE_PHONE_REQUEST = 'PROFILE__UPDATE_MOBILE_PHONE_REQUEST';
export const PROFILE__UPDATE_MOBILE_PHONE_SUCCESS = 'PROFILE__UPDATE_MOBILE_PHONE_SUCCESS';
export const PROFILE__UPDATE_MOBILE_PHONE_FAILURE = 'PROFILE__UPDATE_MOBILE_PHONE_FAILURE';

export const PROFILE__UPDATE_NAME_REQUEST = 'PROFILE__UPDATE_NAME_REQUEST';
export const PROFILE__UPDATE_NAME_SUCCESS = 'PROFILE__UPDATE_NAME_SUCCESS';
export const PROFILE__UPDATE_NAME_FAILURE = 'PROFILE__UPDATE_NAME_FAILURE';

export const PROFILE__UPDATE_DONT_SHOW_AD_REQUEST = 'PROFILE__UPDATE_DONT_SHOW_AD_REQUEST';
export const PROFILE__UPDATE_DONT_SHOW_AD_SUCCESS = 'PROFILE__UPDATE_DONT_SHOW_AD_SUCCESS';
export const PROFILE__UPDATE_DONT_SHOW_AD_FAILURE = 'PROFILE__UPDATE_DONT_SHOW_AD_FAILURE';

// POLICY ACTION TYPES

export const POLICY__UPDATE_NEW_POLICY = 'POLICY__UPDATE_NEW_POLICY';
export const POLICY__CLEAR_NEW_POLICY = 'POLICY__CLEAR_NEW_POLICY';

export const POLICY__ADD_REQUEST = 'POLICY__ADD_REQUEST';
export const POLICY__ADD_SUCCESS = 'POLICY__ADD_SUCCESS';
export const POLICY__ADD_FAILURE = 'POLICY__ADD_FAILURE';

export const POLICY__GET_REQUEST = 'POLICY__GET_REQUEST';
export const POLICY__GET_SUCCESS = 'POLICY__GET_SUCCESS';
export const POLICY__GET_FAILURE = 'POLICY__GET_FAILURE';

export const POLICY__GET_ONETIME_REQUEST = 'POLICY__GET_ONETIME_REQUEST';
export const POLICY__GET_ONETIME_SUCCESS = 'POLICY__GET_ONETIME_SUCCESS';
export const POLICY__GET_ONETIME_FAILURE = 'POLICY__GET_ONETIME_FAILURE';

export const POLICY__REMOVE_REQUEST = 'POLICY__REMOVE_REQUEST';
export const POLICY__REMOVE_SUCCESS = 'POLICY__REMOVE_SUCCESS';
export const POLICY__REMOVE_FAILURE = 'POLICY__REMOVE_FAILURE';

export const POLICY__EDIT_NICKNAME_REQUEST = 'POLICY__EDIT_NICKNAME_REQUEST';
export const POLICY__EDIT_NICKNAME_SUCCESS = 'POLICY__EDIT_NICKNAME_SUCCESS';
export const POLICY__EDIT_NICKNAME_FAILURE = 'POLICY__EDIT_NICKNAME_FAILURE';

// CLAIM ACTION TYPES

export const CLAIM__UPDATE_CLAIM = 'CLAIM__UPDATE_CLAIM';
export const CLAIM__RESET_CLAIM = 'CLAIM__RESET_CLAIM';

export const CLAIM__REPORT_REQUEST = 'CLAIM__REPORT_REQUEST';
export const CLAIM__REPORT_SUCCESS = 'CLAIM__REPORT_SUCCESS';
export const CLAIM__REPORT_FAILURE = 'CLAIM__REPORT_FAILURE';

export const CLAIM__SENDERROREMAIL_REQUEST = 'CLAIM__SENDERROREMAIL_REQUEST';
export const CLAIM__SENDERROREMAIL_SUCCESS = 'CLAIM__SENDERROREMAIL_SUCCESS';
export const CLAIM__SENDERROREMAIL_FAILURE = 'CLAIM__SENDERROREMAIL_FAILURE';

export const CLAIM__SENDDEBUGEMAIL_REQUEST = 'CLAIM__SENDDEBUGEMAIL_REQUEST';
export const CLAIM__SENDDEBUGEMAIL_SUCCESS = 'CLAIM__SENDDEBUGEMAIL_SUCCESS';
export const CLAIM__SENDDEBUGEMAIL_FAILURE = 'CLAIM__SENDDEBUGEMAIL_FAILURE';

// PAYMENT ACTION TYPES

export const PAYMENT__SHOW_RECURRING = 'PAYMENT__SHOW_RECURRING';
export const PAYMENT__RESET_RECURRING = 'PAYMENT__RESET_RECURRING';
export const PAYMENT__UPDATE_RECURRING_PAYMENT_SOURCE = 'PAYMENT__UPDATE_RECURRING_PAYMENT_SOURCE';
export const PAYMENT__RESET_RECURRING_BANK_NAME = 'PAYMENT__RESET_RECURRING_BANK_NAME';
export const PAYMENT__RELOAD_WALLETS = 'PAYMENT__RELOAD_WALLETS';

export const PAYMENT__ADD_RECURRING_REQUEST = 'PAYMENT__ADD_RECURRING_REQUEST';
export const PAYMENT__ADD_RECURRING_SUCCESS = 'PAYMENT__ADD_RECURRING_SUCCESS';
export const PAYMENT__ADD_RECURRING_FAILURE = 'PAYMENT__ADD_RECURRING_FAILURE';

export const PAYMENT__REMOVE_RECURRING_REQUEST = 'PAYMENT__REMOVE_RECURRING_REQUEST';
export const PAYMENT__REMOVE_RECURRING_SUCCESS = 'PAYMENT__REMOVE_RECURRING_SUCCESS';
export const PAYMENT__REMOVE_RECURRING_FAILURE = 'PAYMENT__REMOVE_RECURRING_FAILURE';

export const PAYMENT__GET_BANK_NAME_REQUEST = 'PAYMENT__GET_BANK_NAME_REQUEST';
export const PAYMENT__GET_BANK_NAME_SUCCESS = 'PAYMENT__GET_BANK_NAME_SUCCESS';
export const PAYMENT__GET_BANK_NAME_FAILURE = 'PAYMENT__GET_BANK_NAME_FAILURE';

export const PAYMENT__SUBMIT_REQUEST = 'PAYMENT__SUBMIT_REQUEST';
export const PAYMENT__SUBMIT_SUCCESS = 'PAYMENT__SUBMIT_SUCCESS';
export const PAYMENT__SUBMIT_FAILURE = 'PAYMENT__SUBMIT_FAILURE';

export const PAYMENT__SUBMIT_ONETIME_REQUEST = 'PAYMENT__SUBMIT_ONETIME_REQUEST';
export const PAYMENT__SUBMIT_ONETIME_SUCCESS = 'PAYMENT__SUBMIT_ONETIME_SUCCESS';
export const PAYMENT__SUBMIT_ONETIME_FAILURE = 'PAYMENT__SUBMIT_ONETIME_FAILURE';

export const PAYMENT__GET_SETTINGS_REQUEST = 'PAYMENT__GET_SETTINGS_REQUEST';
export const PAYMENT__GET_SETTINGS_SUCCESS = 'PAYMENT__GET_SETTINGS_SUCCESS';
export const PAYMENT__GET_SETTINGS_FAILURE = 'PAYMENT__GET_SETTINGS_FAILURE';

export const PAYMENT__GET_AUTH_REQUEST = 'PAYMENT__GET_AUTH_REQUEST';
export const PAYMENT__GET_AUTH_SUCCESS = 'PAYMENT__GET_AUTH_SUCCESS';
export const PAYMENT__GET_AUTH_FAILURE = 'PAYMENT__GET_AUTH_FAILURE';

export const PAYMENT__GET_WALLETS_REQUEST = 'PAYMENT__GET_WALLETS_REQUEST';
export const PAYMENT__GET_WALLETS_SUCCESS = 'PAYMENT__GET_WALLETS_SUCCESS';
export const PAYMENT__GET_WALLETS_FAILURE = 'PAYMENT__GET_WALLETS_FAILURE';

export const PAYMENT__GET_RECURRING_REQUEST = 'PAYMENT__GET_RECURRING_REQUEST';
export const PAYMENT__GET_RECURRING_SUCCESS = 'PAYMENT__GET_RECURRING_SUCCESS';
export const PAYMENT__GET_RECURRING_FAILURE = 'PAYMENT__GET_RECURRING_FAILURE';

export const PAYMENT__REMOVE_WALLET_ITEM_REQUEST = 'PAYMENT__REMOVE_WALLET_ITEM_REQUEST';
export const PAYMENT__REMOVE_WALLET_ITEM_SUCCESS = 'PAYMENT__REMOVE_WALLET_ITEM_SUCCESS';
export const PAYMENT__REMOVE_WALLET_ITEM_FAILURE = 'PAYMENT__REMOVE_WALLET_ITEM_FAILURE';

export const PAYMENT__UPDATE_WALLET_ITEM_REQUEST = 'PAYMENT__UPDATE_WALLET_ITEM_REQUEST';
export const PAYMENT__UPDATE_WALLET_ITEM_SUCCESS = 'PAYMENT__UPDATE_WALLET_ITEM_SUCCESS';
export const PAYMENT__UPDATE_WALLET_ITEM_FAILURE = 'PAYMENT__UPDATE_WALLET_ITEM_FAILURE';

export const PAYMENT__ADD_WALLET_REQUEST = 'PAYMENT__ADD_WALLET_REQUEST';
export const PAYMENT__ADD_WALLET_SUCCESS = 'PAYMENT__ADD_WALLET_SUCCESS';
export const PAYMENT__ADD_WALLET_FAILURE = 'PAYMENT__ADD_WALLET_FAILURE';

export const PAYMENT__REMOVE_WALLET_REQUEST = 'PAYMENT__REMOVE_WALLET_REQUEST';
export const PAYMENT__REMOVE_WALLET_SUCCESS = 'PAYMENT__REMOVE_WALLET_SUCCESS';
export const PAYMENT__REMOVE_WALLET_FAILURE = 'PAYMENT__REMOVE_WALLET_FAILURE';

export const PAYMENT__UPDATE_WALLET_REQUEST = 'PAYMENT__UPDATE_WALLET_REQUEST';
export const PAYMENT__UPDATE_WALLET_SUCCESS = 'PAYMENT__UPDATE_WALLET_SUCCESS';
export const PAYMENT__UPDATE_WALLET_FAILURE = 'PAYMENT__UPDATE_WALLET_FAILURE';

export const PAYMENT__GET_SCHEDULED_PAYMENTS_REQUEST = 'PAYMENT__GET_SCHEDULED_PAYMENTS_REQUEST';
export const PAYMENT__GET_SCHEDULED_PAYMENTS_SUCCESS = 'PAYMENT__GET_SCHEDULED_PAYMENTS_SUCCESS';
export const PAYMENT__GET_SCHEDULED_PAYMENTS_FAILURE = 'PAYMENT__GET_SCHEDULED_PAYMENTS_FAILURE';

export const PAYMENT__ADD_SCHEDULED_PAYMENT_REQUEST = 'PAYMENT__ADD_SCHEDULED_PAYMENT_REQUEST';
export const PAYMENT__ADD_SCHEDULED_PAYMENT_SUCCESS = 'PAYMENT__ADD_SCHEDULED_PAYMENT_SUCCESS';
export const PAYMENT__ADD_SCHEDULED_PAYMENT_FAILURE = 'PAYMENT__ADD_SCHEDULED_PAYMENT_FAILURE';

export const PAYMENT__REMOVE_SCHEDULED_PAYMENT_REQUEST = 'PAYMENT__REMOVE_SCHEDULED_PAYMENT_REQUEST';
export const PAYMENT__REMOVE_SCHEDULED_PAYMENT_SUCCESS = 'PAYMENT__REMOVE_SCHEDULED_PAYMENT_SUCCESS';
export const PAYMENT__REMOVE_SCHEDULED_PAYMENT_FAILURE = 'PAYMENT__REMOVE_SCHEDULED_PAYMENT_FAILURE';

// ADMIN ACTION TYPEs
export const ADMIN__GET_ACTIVE_USERS_REQUEST = 'ADMIN__GET_ACTIVE_USERS_REQUEST';
export const ADMIN__GET_ACTIVE_USERS_SUCCESS = 'ADMIN__GET_ACTIVE_USERS_SUCCESS';
export const ADMIN__GET_ACTIVE_USERS_FAILURE = 'ADMIN__GET_ACTIVE_USERS_FAILURE';

export const ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_REQUEST = 'ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_REQUEST';
export const ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_SUCCESS = 'ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_SUCCESS';
export const ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_FAILURE = 'ADMIN__UPDATE_SYSTEM_INFO_MESSAGE_FAILURE';

export const ADMIN__FETCH_ADMIN_STATE_REQUEST = 'ADMIN__FETCH_ADMIN_STATE_REQUEST';
export const ADMIN__FETCH_ADMIN_STATE_SUCCESS = 'ADMIN__FETCH_ADMIN_STATE_SUCCESS';
export const ADMIN__FETCH_ADMIN_STATE_FAILURE = 'ADMIN__FETCH_ADMIN_STATE_FAILURE';

export const ADMIN__FETCH_STAFF_VERIFY_REQUEST = 'ADMIN__FETCH_STAFF_VERIFY_REQUEST';
export const ADMIN__FETCH_STAFF_VERIFY_SUCCESS = 'ADMIN__FETCH_STAFF_VERIFY_SUCCESS';
export const ADMIN__FETCH_STAFF_VERIFY_FAILURE = 'ADMIN__FETCH_STAFF_VERIFY_FAILURE';

export const ADMIN__SEARCH_USERS_REQUEST = 'ADMIN__SEARCH_USERS_REQUEST';
export const ADMIN__SEARCH_USERS_SUCCESS = 'ADMIN__SEARCH_USERS_SUCCESS';
export const ADMIN__SEARCH_USERS_FAILURE = 'ADMIN__SEARCH_USERS_FAILURE';

export const ADMIN__LOGIN_AS_USER_REQUEST = 'ADMIN__LOGIN_AS_USER_REQUEST';
export const ADMIN__LOGIN_AS_USER_SUCCESS = 'ADMIN__LOGIN_AS_USER_SUCCESS';
export const ADMIN__LOGIN_AS_USER_FAILURE = 'ADMIN__LOGIN_AS_USER_FAILURE';

export const ADMIN__UPDATE_STAFF_VERIFY_REQUEST = 'ADMIN__UPDATE_STAFF_VERIFY_REQUEST';
export const ADMIN__UPDATE_STAFF_VERIFY_SUCCESS = 'ADMIN__UPDATE_STAFF_VERIFY_SUCCESS';
export const ADMIN__UPDATE_STAFF_VERIFY_FAILURE = 'ADMIN__UPDATE_STAFF_VERIFY_FAILURE';

export const ADMIN__FETCH_CHAT_OPTIONS_REQUEST = 'ADMIN__FETCH_CHAT_OPTIONS_REQUEST';
export const ADMIN__FETCH_CHAT_OPTIONS_SUCCESS = 'ADMIN__FETCH_CHAT_OPTIONS_SUCCESS';
export const ADMIN__FETCH_CHAT_OPTIONS_FAILURE = 'ADMIN__FETCH_CHAT_OPTIONS_FAILURE';

export const ADMIN__UPDATE_CHAT_OPTIONS_REQUEST = 'ADMIN__UPDATE_CHAT_OPTIONS_REQUEST';
export const ADMIN__UPDATE_CHAT_OPTIONS_SUCCESS = 'ADMIN__UPDATE_CHAT_OPTIONS_SUCCESS';
export const ADMIN__UPDATE_CHAT_OPTIONS_FAILURE = 'ADMIN__UPDATE_CHAT_OPTIONS_FAILURE';
export const ADMIN__ADD_POLICY_TO_USER_REQUEST = 'ADMIN__ADD_POLICY_TO_USER_REQUEST';
export const ADMIN__ADD_POLICY_TO_USER_SUCCESS = 'ADMIN__ADD_POLICY_TO_USER_SUCCESS';
export const ADMIN__ADD_POLICY_TO_USER_FAILURE = 'ADMIN__ADD_POLICY_TO_USER_FAILURE';

export const ADMIN__REMOVE_POLICY_FROM_USER_REQUEST = 'ADMIN__REMOVE_POLICY_FROM_USER_REQUEST';
export const ADMIN__REMOVE_POLICY_FROM_USER_SUCCESS = 'ADMIN__REMOVE_POLICY_FROM_USER_SUCCESS';
export const ADMIN__REMOVE_POLICY_FROM_USER_FAILURE = 'ADMIN__REMOVE_POLICY_FROM_USER_FAILURE';

export const ADMIN__SEND_PASSWORD_RESET_REQUEST = 'ADMIN__SEND_PASSWORD_RESET_REQUEST';
export const ADMIN__SEND_PASSWORD_RESET_SUCCESS = 'ADMIN__SEND_PASSWORD_RESET_SUCCESS';
export const ADMIN__SEND_PASSWORD_RESET_FAILURE = 'ADMIN__SEND_PASSWORD_RESET_FAILURE';

export const ADMIN__SEND_EMAIL_CONFIRMATION_REQUEST = 'ADMIN__SEND_EMAIL_CONFIRMATION_REQUEST';
export const ADMIN__SEND_EMAIL_CONFIRMATION_SUCCESS = 'ADMIN__SEND_EMAIL_CONFIRMATION_SUCCESS';
export const ADMIN__SEND_EMAIL_CONFIRMATION_FAILURE = 'ADMIN__SEND_EMAIL_CONFIRMATION_FAILURE';

export const ADMIN__CHANGE_USER_EMAIL_REQUEST = 'ADMIN__CHANGE_USER_EMAIL_REQUEST';
export const ADMIN__CHANGE_USER_EMAIL_SUCCESS = 'ADMIN__CHANGE_USER_EMAIL_SUCCESS';
export const ADMIN__CHANGE_USER_EMAIL_FAILURE = 'ADMIN__CHANGE_USER_EMAIL_FAILURE';

export const ADMIN__FETCH_UPDATED_USER_REQUEST = 'ADMIN__FETCH_UPDATED_USER_REQUEST';
export const ADMIN__FETCH_UPDATED_USER_SUCCESS = 'ADMIN__FETCH_UPDATED_USER_SUCCESS';
export const ADMIN__FETCH_UPDATED_USER_FAILURE = 'ADMIN__FETCH_UPDATED_USER_FAILURE';

export const ADMIN__DELETE_USER_REQUEST = 'ADMIN__DELETE_USER_REQUEST';
export const ADMIN__DELETE_USER_SUCCESS = 'ADMIN__DELETE_USER_SUCCESS';
export const ADMIN__DELETE_USER_FAILURE = 'ADMIN__DELETE_USER_FAILURE';

export const ADMIN__CREATE_USER_REQUEST = 'ADMIN__CREATE_USER_REQUEST';
export const ADMIN__CREATE_USER_SUCCESS = 'ADMIN__CREATE_USER_SUCCESS';
export const ADMIN__CREATE_USER_FAILURE = 'ADMIN__CREATE_USER_FAILURE';

export const ADMIN__IMPORT_USERS_REQUEST = 'ADMIN__IMPORT_USERS_REQUEST';
export const ADMIN__IMPORT_USERS_SUCCESS = 'ADMIN__IMPORT_USERS_SUCCESS';
export const ADMIN__IMPORT_USERS_FAILURE = 'ADMIN__IMPORT_USERS_FAILURE';

export const ADMIN__GET_IMPORT_STATUS_REQUEST = 'ADMIN__GET_IMPORT_STATUS_REQUEST';
export const ADMIN__GET_IMPORT_STATUS_SUCCESS = 'ADMIN__GET_IMPORT_STATUS_SUCCESS';
export const ADMIN__GET_IMPORT_STATUS_FAILURE = 'ADMIN__GET_IMPORT_STATUS_FAILURE';

export const ADMIN__GET_SYSTEM_TOGGLES_REQUEST = 'ADMIN__GET_SYSTEM_TOGGLES_REQUEST';
export const ADMIN__GET_SYSTEM_TOGGLES_SUCCESS = 'ADMIN__GET_SYSTEM_TOGGLES_SUCCESS';
export const ADMIN__GET_SYSTEM_TOGGLES_FAILURE = 'ADMIN__GET_SYSTEM_TOGGLES_FAILURE';

export const ADMIN__UPDATE_SYSTEM_TOGGLES_REQUEST = 'ADMIN__UPDATE_SYSTEM_TOGGLES_REQUEST';
export const ADMIN__UPDATE_SYSTEM_TOGGLES_SUCCESS = 'ADMIN__UPDATE_SYSTEM_TOGGLES_SUCCESS';
export const ADMIN__UPDATE_SYSTEM_TOGGLES_FAILURE = 'ADMIN__UPDATE_SYSTEM_TOGGLES_FAILURE';

export const ADMIN__UPDATE_DELIVERY_TESTER_REQUEST = 'ADMIN__UPDATE_DELIVERY_TESTER_REQUEST';
export const ADMIN__UPDATE_DELIVERY_TESTER_SUCCESS = 'ADMIN__UPDATE_DELIVERY_TESTER_SUCCESS';
export const ADMIN__UPDATE_DELIVERY_TESTER_FAILURE = 'ADMIN__UPDATE_DELIVERY_TESTER_FAILURE';

export const ADMIN__UPDATE_CLAIMS_DELIVERY_REQUEST = 'ADMIN__UPDATE_CLAIMS_DELIVERY_REQUEST';
export const ADMIN__UPDATE_CLAIMS_DELIVERY_SUCCESS = 'ADMIN__UPDATE_CLAIMS_DELIVERY_SUCCESS';
export const ADMIN__UPDATE_CLAIMS_DELIVERY_FAILURE = 'ADMIN__UPDATE_CLAIMS_DELIVERY_FAILURE';

export const ADMIN__GET_ALL_LOG_FILES_REQUEST = 'ADMIN__GET_ALL_LOG_FILES_REQUEST';
export const ADMIN__GET_ALL_LOG_FILES_SUCCESS = 'ADMIN__GET_ALL_LOG_FILES_SUCCESS';
export const ADMIN__GET_ALL_LOG_FILES_FAILURE = 'ADMIN__GET_ALL_LOG_FILES_FAILURE';

// ENDORSEMENTS
export const POLICYSAVE__REQUEST = 'POLICYSAVE__REQUEST';
export const POLICYSAVE__SUCCESS = 'POLICYSAVE__SUCCESS';
export const POLICYSAVE__FAILURE = 'POLICYSAVE__FAILURE';

export const POLICYSAVE__GET_REQUEST = 'POLICYSAVE__GET_REQUEST';
export const POLICYSAVE__GET_SUCCESS = 'POLICYSAVE__GET_SUCCESS';
export const POLICYSAVE__GET_FAILURE = 'POLICYSAVE__GET_FAILURE';

export const POLICYSAVE__DELETE_REQUEST = 'POLICYSAVE__DELETE_REQUEST';
export const POLICYSAVE__DELETE_SUCCESS = 'POLICYSAVE__DELETE_SUCCESS';
export const POLICYSAVE__DELETE_FAILURE = 'POLICYSAVE__DELETE_FAILURE';

export const POLICYRATE__DRIVER_REQUEST = 'POLICYRATE__DRIVER_REQUEST';
export const POLICYRATE__DRIVER_SUCCESS = 'POLICYRATE__DRIVER_SUCCESS';
export const POLICYRATE__DRIVER_FAILURE = 'POLICYRATE__DRIVER_FAILURE';

export const POLICYRATE__VEHICLE_REQUEST = 'POLICYRATE__VEHICLE_REQUEST';
export const POLICYRATE__VEHICLE_SUCCESS = 'POLICYRATE__VEHICLE_SUCCESS';
export const POLICYRATE__VEHICLE_FAILURE = 'POLICYRATE__VEHICLE_FAILURE';

export const POLICYRATE__CREDITOR_REQUEST = 'POLICYRATE__CREDITOR_REQUEST';
export const POLICYRATE__CREDITOR_SUCCESS = 'POLICYRATE__CREDITOR_SUCCESS';
export const POLICYRATE__CREDITOR_FAILURE = 'POLICYRATE__CREDITOR_FAILURE';

export const POLICYRATE__DELETE_DRIVER_REQUEST = 'POLICYRATE__DELETE_DRIVER_REQUEST';
export const POLICYRATE__DELETE_DRIVER_SUCCESS = 'POLICYRATE__DELETE_DRIVER_SUCCESS';
export const POLICYRATE__DELETE_DRIVER_FAILURE = 'POLICYRATE__DELETE_DRIVER_FAILURE';

export const POLICYRATE__DELETE_VEHICLE_REQUEST = 'POLICYRATE__DELETE_VEHICLE_REQUEST';
export const POLICYRATE__DELETE_VEHICLE_SUCCESS = 'POLICYRATE__DELETE_VEHICLE_SUCCESS';
export const POLICYRATE__DELETE_VEHICLE_FAILURE = 'POLICYRATE__DELETE_VEHICLE_FAILURE';

export const POLICYRATE__DELETE_CREDITOR_REQUEST = 'POLICYRATE__DELETE_CREDITOR_REQUEST';
export const POLICYRATE__DELETE_CREDITOR_SUCCESS = 'POLICYRATE__DELETE_CREDITOR_SUCCESS';
export const POLICYRATE__DELETE_CREDITOR_FAILURE = 'POLICYRATE__DELETE_CREDITOR_FAILURE';

export const POLICYRATE__CONFIRM_REQUEST = 'POLICYRATE__CONFIRM_REQUEST';
export const POLICYRATE__CONFIRM_SUCCESS = 'POLICYRATE__CONFIRM_SUCCESS';
export const POLICYRATE__CONFIRM_FAILURE = 'POLICYRATE__CONFIRM_FAILURE';

export const POLICYRATE__DELETE_REQUEST = 'POLICYRATE__DELETE_REQUEST';
export const POLICYRATE__DELETE_SUCCESS = 'POLICYRATE__DELETE_SUCCESS';
export const POLICYRATE__DELETE_FAILURE = 'POLICYRATE__DELETE_FAILURE';

export const POLICYRATE__SENDERROREMAIL_REQUEST = 'POLICYRATE__SENDERROREMAIL_REQUEST';
export const POLICYRATE__SENDERROREMAIL_SUCCESS = 'POLICYRATE__SENDERROREMAIL_SUCCESS';
export const POLICYRATE__SENDERROREMAIL_FAILURE = 'POLICYRATE__SENDERROREMAIL_FAILURE';

//VEHICLES
export const VEHICLE__LOOKUP_REQUEST = 'VEHICLE__LOOKUP_REQUEST';
export const VEHICLE__LOOKUP_SUCCESS = 'VEHICLE__LOOKUP_SUCCESS';
export const VEHICLE__LOOKUP_FAILURE = 'VEHICLE__LOOKUP_FAILURE';

//ADDRESSES
export const ADDRESS__LOOKUP_REQUEST = 'ADDRESS__LOOKUP_REQUEST';
export const ADDRESS__LOOKUP_SUCCESS = 'ADDRESS__LOOKUP_SUCCESS';
export const ADDRESS__LOOKUP_FAILURE = 'ADDRESS__LOOKUP_FAILURE';

export const ADMIN__ADVERTISEMENTS_GETALL_REQUEST = 'ADMIN__ADVERTISEMENTS_GETALL_REQUEST';
export const ADMIN__ADVERTISEMENTS_GETALL_SUCCESS = 'ADMIN__ADVERTISEMENTS_GETALL_SUCCESS';
export const ADMIN__ADVERTISEMENTS_GETALL_FAILURE = 'ADMIN__ADVERTISEMENTS_GETALL_FAILURE';

export const ADMIN__ADVERTISEMENTS_ADD_REQUEST = 'ADMIN__ADVERTISEMENTS_ADD_REQUEST';
export const ADMIN__ADVERTISEMENTS_ADD_SUCCESS = 'ADMIN__ADVERTISEMENTS_ADD_SUCCESS';
export const ADMIN__ADVERTISEMENTS_ADD_FAILURE = 'ADMIN__ADVERTISEMENTS_ADD_FAILURE';

export const ADMIN__ADVERTISEMENTS_UPDATE_REQUEST = 'ADMIN__ADVERTISEMENTS_UPDATE_REQUEST';
export const ADMIN__ADVERTISEMENTS_UPDATE_SUCCESS = 'ADMIN__ADVERTISEMENTS_UPDATE_SUCCESS';
export const ADMIN__ADVERTISEMENTS_UPDATE_FAILURE = 'ADMIN__ADVERTISEMENTS_UPDATE_FAILURE';

export const ADMIN__ADVERTISEMENTS_REMOVE_REQUEST = 'ADMIN__ADVERTISEMENTS_REMOVE_REQUEST';
export const ADMIN__ADVERTISEMENTS_REMOVE_SUCCESS = 'ADMIN__ADVERTISEMENTS_REMOVE_SUCCESS';
export const ADMIN__ADVERTISEMENTS_REMOVE_FAILURE = 'ADMIN__ADVERTISEMENTS_REMOVE_FAILURE';

export const ADMIN__ADVERTISEMENTS__RESET_REQUEST = 'ADMIN__ADVERTISEMENTS__RESET_REQUEST';
export const ADMIN__ADVERTISEMENTS__RESET_SUCCESS = 'ADMIN__ADVERTISEMENTS__RESET_SUCCESS';
export const ADMIN__ADVERTISEMENTS__RESET_FAILURE = 'ADMIN__ADVERTISEMENTS__RESET_FAILURE';

//Calculate Convience Fee

export const PAYMENT__CALCULATEFEE_REQUEST = 'PAYMENT__CALCULATEFEE_REQUEST';
export const PAYMENT__CALCULATEFEE_SUCCESS = 'PAYMENT__CALCULATEFEE_SUCCESS';
export const PAYMENT__CALCULATEFEE_FAILURE = 'PAYMENT__CALCULATEFEE_FAILURE';

//Calculate Convience Fee

export const PAYMENT__GET_CALCULATEFEE_REQUEST = 'PAYMENT__GET_CALCULATEFEE_REQUEST';
export const PAYMENT__GET_CALCULATEFEE_SUCCESS = 'PAYMENT__GET_CALCULATEFEE_SUCCESS';
export const PAYMENT__GET_CALCULATEFEE_FAILURE = 'PAYMENT__GET_CALCULATEFEE_FAILURE';

//Calculate Scheduled Convience Fee

export const PAYMENT__SCHEDULED_CALCULATEFEE_REQUEST = 'PAYMENT__SCHEDULED_CALCULATEFEE_REQUEST';
export const PAYMENT__SCHEDULED_CALCULATEFEE_SUCCESS = 'PAYMENT__SCHEDULED_CALCULATEFEE_SUCCESS';
export const PAYMENT__SCHEDULED_CALCULATEFEE_FAILURE = 'PAYMENT__SCHEDULED_CALCULATEFEE_FAILURE';




